"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var campaign_model_1 = require("../../model/campaign.model");
var decorators_1 = require("../../decorator/decorators");
var config_1 = require("../../dic/config");
var campaign_repository_1 = require("../../repositories/campaign.repository");
var optin_client_1 = require("@riverline/optin-client");
var market_model_1 = require("../../model/market.model");
var vue_property_decorator_1 = require("vue-property-decorator");
require("@riverline/optin-brand/dist/optin-brand-advertisers.css");
var consent_advertiser_model_1 = require("../../model/consent-advertiser.model");
var CONSENT_STEPS = [
    {
        labelKey: 'campaigns.sponsoring.bat.steps.electronic',
        channels: 'email,sms,tracking_open',
        display: 'legal,-purposes'
    },
    {
        labelKey: 'campaigns.sponsoring.bat.steps.phone',
        channels: 'phone',
        display: 'legal'
    }
];
var consentPopupBundle = null;
function loadConsentPopupBundle() {
    if (null === consentPopupBundle) {
        consentPopupBundle = Promise.resolve().then(function () { return require('@riverline/optin-brand/dist/optin-brand.advertisers.esm.js'); });
    }
    return consentPopupBundle;
}
var SponsoringBatComponent = (function (_super) {
    __extends(SponsoringBatComponent, _super);
    function SponsoringBatComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SponsoringBatComponent.prototype.data = function () {
        return {
            hasAd: false,
            consentAdvertiser: null,
            consentPopupState: 'loading'
        };
    };
    Object.defineProperty(SponsoringBatComponent.prototype, "steps", {
        get: function () {
            var _this = this;
            return CONSENT_STEPS.map(function (step) { return ({
                label: _this.$t(step.labelKey),
                title: _this.$t(step.labelKey + '_title'),
                channels: step.channels,
                display: step.display
            }); });
        },
        enumerable: false,
        configurable: true
    });
    SponsoringBatComponent.prototype.mounted = function () {
        this.getAdAndRender();
    };
    SponsoringBatComponent.prototype.locale = function () {
        switch (this.campaign.market) {
            case market_model_1.MarketEnum.IT:
                return 'it_IT';
            case market_model_1.MarketEnum.ES:
                return 'es_ES';
            default:
                return 'fr_FR';
        }
    };
    SponsoringBatComponent.prototype.getAdAndRender = function () {
        var _this = this;
        var locale = this.locale();
        optin_client_1.OptinCollect.Configuration.setParameter(optin_client_1.OptinCollect.ParameterEnum.Locale, locale);
        optin_client_1.OptinCollect.Configuration.setParameter(optin_client_1.OptinCollect.ParameterEnum.DataSource, 'memory');
        var configuration = new optin_client_1.OptinCollect.Sponsoring.Configuration(945, 'sponsors', 'modals', 'application-tracking');
        var data = new optin_client_1.OptinCollect.CollectedData();
        this.campaignRepository.getAd(this.campaign.uuid, this.token).then(function (ad) {
            _this.hasAd = true;
            _this.consentAdvertiser = consent_advertiser_model_1.consentAdvertiserOf(ad);
            _this.installConsentPopup();
            optin_client_1.OptinCollect.InMemoryRepository.setAds([ad]);
            _this.sponsoringRenderer = new optin_client_1.OptinCollect.Sponsoring.Renderer(configuration, data);
            _this.sponsoringRenderer.render();
        });
    };
    SponsoringBatComponent.prototype.installConsentPopup = function () {
        var _this = this;
        var _a, _b;
        if (null === this.consentAdvertiser) {
            return;
        }
        var installed = window.OptinCollectSettings;
        if (undefined !== installed) {
            if (((_b = (_a = installed.advertisers_data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.advertiserId) !==
                this.consentAdvertiser.advertiserId) {
                window.location.reload();
                return;
            }
        }
        else {
            window.OptinCollectSettings = {
                publisher_key: '',
                publisher_id: 0,
                locale: this.locale(),
                data_source: 'memory',
                advertisers_data: [this.consentAdvertiser],
                configuration: {
                    support_location_id: 945,
                    application_tracking: 'application-tracking'
                }
            };
        }
        loadConsentPopupBundle().then(function () {
            _this.consentPopupState = 'ready';
        }, function (error) {
            console.error('[OptinCollect] popin partenaire indisponible', error);
            _this.consentPopupState = 'failed';
        });
    };
    __decorate([
        decorators_1.Container(config_1.default.REPOSITORY_CAMPAIGN),
        __metadata("design:type", campaign_repository_1.CampaignRepository)
    ], SponsoringBatComponent.prototype, "campaignRepository", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", campaign_model_1.Campaign)
    ], SponsoringBatComponent.prototype, "campaign", void 0);
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", Object)
    ], SponsoringBatComponent.prototype, "token", void 0);
    SponsoringBatComponent = __decorate([
        vue_class_component_1.default({})
    ], SponsoringBatComponent);
    return SponsoringBatComponent;
}(vue_1.default));
exports.default = SponsoringBatComponent;
